import closeImg from '../../assets/icons/closeImg.svg'

interface ModalCloseProps {
  onClick: () => void;
  className?: string
}

const ModalClose: React.FC<ModalCloseProps> = ({ onClick, className }) => {
  return (
    <div
      onClick={onClick}
      className={`w-6 h-6 sm:w-8 sm:h-8 rounded-[10px] bg-gray-200 flex items-center justify-center self-end mb-4 sm:mb-10 cursor-pointer hover:bg-gray-300 transition-colors ${className}`}
    >
      <img src={closeImg} alt="Close" className="w-4 h-4 sm:w-5 sm:h-5" />
    </div>
  )
}

export default ModalClose
